import { isProductionEnvironment } from '../../../utils/env';

export const getInitialState = isRenderedOnServer => {
  if (isProductionEnvironment()) {
    if (isRenderedOnServer) {
      return {
        formIntroduction:
          '{% if formIntroduction is defined %}{{ formIntroduction|raw }} {% endif %}',
        formDonatorLabel:
          "{% if formDonatorLabel is defined %}{{ formDonatorLabel|default('Imię i nazwisko zamawiającego (opcjonalnie)') }} {% endif %}",
      };
    }

    return null;
  }

  return {
    formIntroduction: '<p>Polecam Panu Bogu i modlitwom kościoła zmarłych:</p>',
    formDonatorLabel: 'Imię i nazwisko zamawiającego (opcjonalnie)',
  };
};
